module.exports = __webpack_public_path__ + "img/caas3-m@1.f3dff934.jpg";